import script from "./DeleteConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteConfirmationDialog.vue?vue&type=style&index=0&id=07e72fde&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e72fde"]])

export default __exports__